import React from 'react';

const NotFoundPage = () => {
    return (
        <section>
            <div className={`flex justify-center w-full sm:w-[65%] md:w-[60%] lg:w-[40%] mx-auto items-center max-h-screen`}>
                <img src="https://i.ibb.co/f1rPLWq/Oops-404-Error-with-a-broken-robot-pana.png" alt="404 Not Found" />
            </div>
        </section>
    );
};

export default NotFoundPage;